import EnvironmentBadge from "@/components/EnvironmentBadge";
import { Outlet } from "react-router-dom";
import { OnboardingGuard } from "@/components/OnboardingGuard";
import { Header } from "@/components/Header";
import { DrawerProvider } from "@/context/DrawerContext";

export const MainLayoutWithoutNavigation = () => {
  return (
    <DrawerProvider>
    <OnboardingGuard>
      <div className="flex min-h-screen flex-col bg-theme-layout-bg">
        {/* Environment Badge */}
        <EnvironmentBadge />
        {/* Header (Profile + Logout) */}
        <Header />
        {/* Main Content */}
        <main className="flex h-[calc(100vh-var(--layout-top-header-height))]">
          <div className="flex-1 min-h-0 p-3 bg-surface-page-bg overflow-y-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </OnboardingGuard>
    </DrawerProvider>
  );
};
